import { Close } from "@mui/icons-material";
import { Dialog, IconButton, Typography, Autocomplete, TextField } from "@mui/material";
import { ModalItemsContainer } from "components/CustomModal/Styles";
import {
  FormikPasswordField,
  FormikTextField,
  SubmitButton,
} from "components/form-components/CustomFormikFields";
import { useImportAttendeesMutation } from "features/Attendees/attendeesApiSlice";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useGetAttendeeTagsQuery } from "features/Attendees/attendeesApiSlice";

const ImportAttendeesDialog = ({ open, onClose, onImport }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [inputValue, setInputValue] = useState(""); // Track raw input for tags
  const [importAttendees, { isLoading: isImportLoading }] = useImportAttendeesMutation();
  const { data: tags, isLoading: isTagsLoading } = useGetAttendeeTagsQuery();
  const handleSubmit = async ({ attendee_data, password, tags }) => {
    const formData = new FormData();
    formData.append("attendee_data", attendee_data);
    formData.append("password", password);
    if (tags && tags.length > 0) {
      tags.forEach((tag) => formData.append("tags[]", tag)); // Append each tag to FormData
    }

    try {
      const res = await importAttendees(formData).unwrap();
      if (res?.error) {
        throw new Error(res.error?.data?.message);
      }

      setErrorMessage("");
      onImport();
      onClose();
    } catch (err) {
   
      setErrorMessage(err.data.message || "Failed to import attendees");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <ModalItemsContainer>
        <IconButton
          onClick={onClose}
          sx={{
            alignSelf: "flex-end",
            position: "absolute",
            top: "0",
            right: "0",
            mb: 8,
          }}
        >
          <Close />
        </IconButton>
        <Typography
          align="center"
          variant="p"
          sx={{ mb: 3, fontSize: 20, color: "red" }}
        >
          {errorMessage}
        </Typography>
        <Typography
          align="center"
          variant="h2"
          sx={{ fontWeight: 700, mb: 1, fontSize: 24, color: "primary.main" }}
        >
          Import Contacts
        </Typography>

        <Formik
          initialValues={{ attendee_data: null, password: "", tags: [] }}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, isSubmitting, values }) => (
            <Form>
              <FormikTextField
                fullWidth
                margin="dense"
                type="file"
                name="file"
                label=" "
                accept=".csv"
                onChange={(event) => {
                  const selectedFile = event.currentTarget.files[0];
                  const allowedExtensions = /\.csv$/i;

                  if (
                    selectedFile &&
                    !allowedExtensions.test(selectedFile.name)
                  ) {
                    setErrorMessage("Please select a .csv file.");
                    event.currentTarget.value = null;
                  } else {
                    setFieldValue("attendee_data", selectedFile);
                    setErrorMessage("");
                  }
                }}
              />
              <Autocomplete
                multiple
                freeSolo
                options={tags && Array.isArray(tags) ? tags : []}
                value={values.tags || []}
                onChange={(event, newValue) => {
                  setFieldValue("tags", newValue);
                  setInputValue(""); // Clear input after adding tag
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === "input") {
                    setInputValue(newInputValue);
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && inputValue.trim()) {
                    event.preventDefault();
                    const newTags = [...(values.tags || []), inputValue.trim()];
                    setFieldValue("tags", newTags);
                    setInputValue("");
                  }
                }}
                disabled={isTagsLoading}
                renderInput={(params) => (
                  <TextField
            
                    {...params}
                    margin="dense"
                    label="Tags (e.g., Traditional Dancer, Tourism Promoter)"
                    placeholder="Add tags (press Enter to confirm)"
                    onKeyDown={(event) => {
                      if (event.key === ",") {
                        event.preventDefault();
                        setInputValue((prev) => prev + ",");
                      }
                    }}
                  />
                )}
              />
              <FormikPasswordField
                required
                fullWidth
                margin="dense"
                id="password"
                name="password"
                label="Password"
              />
              <SubmitButton text="Import" isSubmitting={isImportLoading || isSubmitting} />
            </Form>
          )}
        </Formik>
      </ModalItemsContainer>
    </Dialog>
  );
};

export default ImportAttendeesDialog;